import { useState } from "react";
import DivStyle from "../style/div.component";
import ButtonStyle from "../style/button.component";
import InputFormStyle from "../style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import AdminAPI from "../../api/admin";
import TableStyle from "../style/table.component";
interface SellerProps {
  setUserIds: (value: number[]) => void;
  setUserNames: (value: string[]) => void;
  setIsOpen: (value: any) => void;
}
const SearchUsers = (props: SellerProps) => {
  const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);
  const [selectedUserNames, setSelectedUserNames] = useState<string[]>([]);
  const [dataList, setDataList] = useState([]);
  const { setUserIds, setUserNames, setIsOpen } = props;

  const [search, setSearch] = useState("");
  const headers = [
    {
      text: "id",
      align: "center",
      value: "id",
      sortable: false,
    },
    {
      text: "이름",
      align: "center",
      value: "username",
      sortable: false,
    },
    {
      text: "닉네임",
      align: "center",
      value: "nickname",
      sortable: false,
    },
  ];

  const getList = async () => {
    const res = await AdminAPI.findUsers(search.toLowerCase(), 0, 9999);
    if (res && res.status === 200) {
      setDataList(res.data.userList);
    }
  };

  const setData = () => {
    setUserIds(selectedUserIds);
    setUserNames(selectedUserNames);
    setIsOpen(false);
  };

  const handleRadioChange = (id: number) => {
    if (selectedUserIds.includes(id)) {
      const deletedData = dataList.find((data) => data["id"] === id);
      if (deletedData) {
        setSelectedUserIds(
          selectedUserIds.filter((id) => id !== deletedData["id"]),
        );
        setSelectedUserNames(
          selectedUserNames.filter((name) => name !== deletedData["username"]),
        );
      }
      return;
    }

    const newData = dataList.find((data) => data["id"] === id);
    if (newData) {
      setSelectedUserIds([...selectedUserIds, newData["id"]]);
      setSelectedUserNames([...selectedUserNames, newData["username"]]);
    }
  };

  return (
    <DivStyle
      style={{
        maxWidth: "500px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        minWidth: "300px",
      }}
      borderRadius="10px"
      position="fixed"
      width="90%"
      height="auto"
      backgroundColor="black"
      color="white"
      display="flex"
      flex_direction="column"
      align_items="center"
    >
      <h4>유저 검색</h4>
      <DivStyle
        width="80%"
        display="flex"
        flex_direction="row"
        align_items="center"
      >
        <InputFormStyle
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              getList();
            }
          }}
        ></InputFormStyle>
        <div onClick={() => getList()}>
          <Icon path={mdiMagnify} size={1} />
        </div>
      </DivStyle>
      <TableStyle
        marginTop="30px"
        width="90%"
        style={{ height: "200px", overflowY: "auto", display: "block" }}
      >
        <thead>
          <tr>
            <th></th>
            {headers.map((header) => (
              <th key={header.value}>{header.text}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataList.map((data: any) => (
            <tr key={data["id"]} onClick={() => handleRadioChange(data["id"])}>
              <td>
                <input
                  type="checkbox"
                  name="selectRow"
                  value={String(data["id"])}
                  checked={selectedUserIds.includes(data["id"])}
                />
              </td>
              {headers.map((header) =>
                header.value === "data.name" ? (
                  <td key={header.value}>{data["data"].name}</td>
                ) : (
                  <td key={header.value}>{data[header.value]}</td>
                ),
              )}
            </tr>
          ))}
        </tbody>
      </TableStyle>
      <DivStyle
        display="flex"
        flex_direction="row"
        width="auto"
        marginTop="30px"
        marginBottom="30px"
      >
        <ButtonStyle
          color="white"
          border="none"
          borderRadius="5px"
          width="100px"
          height="40px"
          marginRight="5px"
          backgroundColor="#1976D2"
          onClick={() => setData()}
        >
          적용
        </ButtonStyle>
        <ButtonStyle
          color="white"
          backgroundColor="#757575"
          border="none"
          borderRadius="5px"
          width="100px"
          height="40px"
          marginLeft="5px"
          onClick={() => setIsOpen(false)}
        >
          닫기
        </ButtonStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default SearchUsers;
